export enum PresentationSubMode {
  Standalone = 0,
  Video = 1,
  VideoMap = 2,
  Navigator = 3,
  Observer = 4,
  VideoObserver = 5,
}
